<template>
  <b-modal
    ref="propostasSelecionadas"
    size="sm"
    no-close-on-esc
    no-close-on-backdrop
    hide-header
    hide-footer
  >
    <div>
      <div class="title-propostas-selecionadas">
        <span>
          Deseja enviar a(s) proposta(s) selecionada(s) agora?
        </span>
      </div>
      <vue-good-table
        :columns="[{ label: 'Número', field: 'numeroProposta', thClass: 'style-dados', sortable: false }]"
        :rows="propostasSelecionadas"
        theme="view"
        max-height="300px"
        :fixed-header="true"
        :row-style-class="'style-dados'"
        style-class="vgt-table striped bordered"
      >
        <template
          slot="table-row"
          slot-scope="props"
        >
          <span v-if="props.column.field === 'numeroProposta'">
            {{ props.row.numeroProposta }}
          </span>
        </template>
      </vue-good-table>
      <div
        v-for="msg in semTemplate"
        :key="msg"
      >
        <span>{{ msg }}</span>
      </div>
      <div style="display: flex;justify-content: center;align-items: center;margin: 1.25em auto 0;">
        <div>
          <b-btn
            variant="primary"
            class="mr-50"
            @click="$emit('enviar-propostas-agrupadas')"
          >
            Sim
          </b-btn>
        </div>
        <div>
          <b-btn
            variant="danger"
            @click="$refs.propostasSelecionadas.hide()"
          >
            Não
          </b-btn>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";

.title-propostas-selecionadas {
  max-width: 100%;
  margin: 0 0 0.4em;
  color: #595959;
  font-size: 1.5rem;
  font-weight: 600;
  text-align: center;
}
</style>

<script>
import { VueGoodTable } from 'vue-good-table'

export default {
  name: 'TabelaPropostasSelecionadas',
  components: {
    VueGoodTable,
  },
  props: {
    propostasSelecionadas: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    show() {
      this.$refs.propostasSelecionadas.show()
    },
  },
}
</script>
